<div class="page-content-small page-fill d-flex flex-column">
    <div class="d-flex">
        <div class="column ms-2 me-2"><span class="color-legend with-border quote"></span> - Quote</div>
        @if (!isQuotesMode) {
        <div class="column ms-2 me-2"><span class="color-legend with-border warranty"></span> - Warranty</div>
        <div class="column ms-2 me-2"><span class="color-legend with-border retail-parts"></span> - Retail Parts</div>
        <div class="column ms-2 me-2"><span class="color-legend with-border sales-order"></span> - Sales Order - NEW</div>
        <div class="column ms-2 me-2"><span class="color-legend with-border waiting-on-dealer-confirmation"></span> - Sales Order - Waiting on Confirmation</div>
        }
    </div>
    <div class="flex-fill d-flex flex-column">
        <div class="m-1 grid-fill">
            <dx-data-grid
                #dataGrid
                [dataSource]="orders"
                keyExpr="id"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="selectionChange($event)"
                (onCellDblClick)="rowDoubleClick($event)"
                (onOptionChanged)="onOptionChanged($event)"
                (onContentReady)="onContentReady($event)"
                (onRowPrepared)="rowPrepare($event)"
                (onExporting)="onExporting($event)"
            >
                <!-- <dxi-column dataField="id" width="40"></dxi-column> -->
                <dxi-column dataField="invoiceNumber" caption="Sales Order #" width="80"></dxi-column>
                <dxi-column dataField="type.name" caption="Type" width="80"></dxi-column>
                <dxi-column dataField="dealer.companyName" caption="Dealer" width="200"></dxi-column>
                <dxi-column dataField="salesRep.name" caption="Sales Rep" width="150"></dxi-column>
                <dxi-column dataField="pONumber" caption="PO #" width="200"></dxi-column>
                <dxi-column dataField="shippingAddressDisplay" caption="Shipping" width="200"></dxi-column>
                <dxi-column dataField="createDate" caption="Order Date" width="100"></dxi-column>
                <dxi-column dataField="statusName" caption="Status" width="100"></dxi-column>
                <dxi-column dataField="deliveryOption.name" caption="Delivery Option" width="125"></dxi-column>
                <dxi-column dataField="total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                <dxi-column dataField="paymentMethod" width="200"></dxi-column>

                <div *dxTemplate="let item of 'columnTemplate'">
                    <div style="font-weight: bold">{{ item.data.shipToLocation }}</div>
                    <div>{{ item.data.shipToAddress1 }}</div>
                    <div [hidden]="!item.data.shipToAddress2">{{ item.data.shipToAddress2 }}</div>
                    <div>{{ item.data.shipToCity }}, {{ item.data.shipToState }} {{ item.data.shipToZip }} {{ item.data.shipToCountry }}</div>
                </div>

                <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
                <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="order-search-grid"></dxo-state-storing>
                <dxo-selection [mode]="'multiple'"></dxo-selection>
                
                <dxo-summary>
                    <dxi-total-item column="total" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                </dxo-summary>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button
                        type="button"
                        [hidden]="false"
                        (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                        class="btn btn-success"
                    >
                        Open
                    </button>
                    <button type="button" [hidden]="false" (click)="open()" class="btn btn-secondary ms-2">New{{ isQuotesMode ? ' Quote' : ''}}</button>
                    <button type="button" (click)="print()" class="btn btn-success ms-4">Print {{ isQuotesMode ? 'Quote' : 'Sales Order' }}</button>
                    <button
                        type="button"
                        (click)="cancelOrder()"
                        class="btn btn-danger ms-4"
                        [hidden]="!canCancelOrder"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    >
                        Cancel {{ isQuotesMode ? 'Quote' : 'Order' }}
                    </button>
                    @if (!isQuotesMode) {
                    <button type="button" (click)="toggleCompleted()" class="btn btn-sm btn-warning ms-4">
                        {{ filter.showCompleted ? 'Hide Completed' : 'Show Completed' }}
                    </button>

                    <button
                        type="button"
                        class="btn btn-sm btn-primary ms-2"
                        (click)="updateStatus()"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                        [hidden]="!canUpdateStatus"
                    >
                        Update Status
                    </button>
                    <button class="btn btn-sm btn-success ms-2" (click)="createInvoice()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Create Invoice</button>
                    }
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="orders" class="me-3"
                        ><strong
                            >{{ dataGrid.instance.totalCount() + ' items' }}
                            {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                        </strong></span
                    >
                </div>
            </dx-data-grid>
        </div>
    </div>
</div>
